import React, { useState, useEffect } from 'react'
import { 
  Modal, ModalHeader, ModalBody, ModalFooter, 
  Card, CardHeader, CardBody,
  Button, Row, Col, Label,
  CustomInput, Input 
} from 'reactstrap'
import { MdDesktopWindows, MdTablet, MdSmartphone } from 'react-icons/md'
import { StyleRoot } from 'proofpoint-radium'
import Frame from 'react-frame-component'
import { Helmet } from 'react-helmet'

import CoreRenderFunction from 'containers/TemplateEditor/core/render'
import Lang from 'Lang/General'

import "./index.scss"

const ViewportSizeSelector = ({
  currentView,
  setView
}) => {
  return (
    <div className="d-flex align-items-center justify-content-center py-2">
      <div>
        <Button 
          color={ currentView == 'desktop' ? 'primary' : 'light' }
          style={{
            borderRadius: "5px 0 0 5px",
            padding: "5px 40px"
          }}
          onClick={() => setView( 'desktop' )}>
          <MdDesktopWindows style={{ fontSize: '24px' }} />
        </Button>
        <Button 
          color={ currentView === 'tablet' ? 'primary' : 'light' }
          style={{
            borderRadius: "0",
            padding: "5px 40px"
          }}
          onClick={() => setView( 'tablet' )}>
          <MdTablet style={{ fontSize: '24px' }} />
        </Button>
        <Button 
          color={ currentView === 'mobile' ? 'primary' : 'light' }
          style={{
            borderRadius: "0 5px 5px 0",
            padding: "5px 40px"
          }}
          onClick={() => setView( 'mobile' )}>
          <MdSmartphone style={{ fontSize: '24px' }} />
        </Button>
      </div>
    </div>
  )
}

const ImagePosition = props => {
  let {
    selectedDom,
    onEdit,
    stylesheets,
    javascripts,
    showModal,
    setShowModal,
    selectedLanguageShortname,
    style,
  } = props
  const [ screenView, setScreenView ] = useState( "desktop" )
  const [ bgPosition, setBgPosition ] = useState([ 0, 0 ])
  const [ imageSizeType, setImageSizeType ] = useState("cover")
  const [ imageSize, setImageSize ] = useState([ "auto", "auto" ])

  useEffect(()=>{
    if( style ){
      switch ( screenView ){
        case "desktop":
          delete style[ "@media (min-width: 992px)" ]
          if( style[ "@media (min-width: 768px)" ]){
            if( style[ "@media (min-width: 768px)" ].backgroundPosition ){
              let tmp = style[ "@media (min-width: 768px)" ].backgroundPosition.split(" ")
              setBgPosition([ parseInt( tmp[0] ), parseInt( tmp[1] ) ])
            } else {
              setBgPosition([ 0, 0 ])
            }
            if( style[ "@media (min-width: 768px)" ].backgroundSize ){
              if( /\d/.test( style[ "@media (min-width: 768px)" ].backgroundSize ) || style[ "@media (min-width: 768px)" ].backgroundSize === "auto auto" ){
                setImageSizeType( "custom" )
                let tmp = style[ "@media (min-width: 768px)" ].backgroundSize.split(" ")
                setImageSize([ parseInt( tmp[0] ), parseInt( tmp[1] ) ])
              } else {
                setImageSizeType( style[ "@media (min-width: 768px)" ].backgroundSize )
              }
            } else {
              setImageSizeType( "cover" )
            }
          } else {
            setBgPosition([ 0, 0 ])
            setImageSizeType( "cover" )
          }
          break
        case "tablet":
          if( style[ "@media (min-width: 768px)" ]){
            if( style[ "@media (min-width: 768px)" ].backgroundPosition ){
              let tmp = style[ "@media (min-width: 768px)" ].backgroundPosition.split(" ")
              setBgPosition([ parseInt( tmp[0] ), parseInt( tmp[1] ) ])
            } else {
              setBgPosition([ 0, 0 ])
            }
            if( style[ "@media (min-width: 768px)" ].backgroundSize ){
              if( /\d/.test( style[ "@media (min-width: 768px)" ].backgroundSize ) || style[ "@media (min-width: 768px)" ].backgroundSize === "auto auto"){
                setImageSizeType( "custom" )
                let tmp = style[ "@media (min-width: 768px)" ].backgroundSize.split(" ")
                setImageSize([ parseInt( tmp[0] ), parseInt( tmp[1] ) ])
              } else {
                setImageSizeType( style[ "@media (min-width: 768px)" ].backgroundSize )
              }
            } else {
              setImageSizeType( "cover" )
            }
          } else {
            setBgPosition([ 0, 0 ])
            setImageSizeType( "cover" )
          }
          break
        case "mobile":
          if( style.backgroundPosition ){
            let tmp = style.backgroundPosition.split(" ")
            setBgPosition([ parseInt( tmp[0] ), parseInt( tmp[1] ) ])
          } else {
            setBgPosition([ 0, 0 ])
          }
          if( style.backgroundSize ){
            if( /\d/.test( style.backgroundSize ) || style.backgroundSize === "auto auto" ){
              setImageSizeType( "custom" )
              let tmp = style.backgroundSize.split(" ")
              setImageSize([ parseInt( tmp[0] ), parseInt( tmp[1] ) ])
            } else {
              setImageSizeType( style.backgroundSize )
            }
          } else {
            setImageSizeType( "cover" )
          }
          break
        default:
      }
    }
  }, [ style, screenView ])

  return(
    <Modal 
      isOpen={ showModal } 
      style={{ maxWidth: '100vw' }}>
      <ModalHeader toggle={ () => setShowModal( false ) } >
        { Lang[ 'IMAGE_POSITION_ADJUSTMENT' ][ selectedLanguageShortname ] }
      </ModalHeader>
      <ModalBody>
        <ViewportSizeSelector 
          currentView={ screenView }
          setView={ view => setScreenView( view ) }
        />
        <Row className=" mb-3">
          <Col md={4}>
            <Card style={{ height: '100%' }}>
              <CardHeader>{ Lang[ 'HORIZONTAL' ][ selectedLanguageShortname ] } - %</CardHeader>
              <CardBody className="d-flex align-items-center">
                <Row>
                  <Col sm={9} className="d-flex align-items-center">
                    <CustomInput
                      value={ bgPosition[0] }
                      type="range"
                      min={ 0 }
                      max={ 100 }
                      onChange={ e => onEdit( 'backgroundPosition', `${ e.target.value }% ${ bgPosition[1] }%`, screenView )}
                    />
                  </Col>
                  <Col sm={3} className="p-0">
                    <Input 
                      type="number"
                      value={ bgPosition[0] }
                      onChange={ e => onEdit( 'backgroundPosition', `${ e.target.value }% ${ bgPosition[1] }%`, screenView )}/>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card style={{ height: '100%' }}>
              <CardHeader>{ Lang[ 'VERTICAL' ][ selectedLanguageShortname ] } - %</CardHeader>
              <CardBody className='d-flex align-items-center'>
                <Row>
                  <Col sm={9} className="d-flex align-items-center">
                    <CustomInput
                      value={ bgPosition[1] }
                      type="range"
                      min={ 0 }
                      max={ 100 }
                      onChange={ e => onEdit( 'backgroundPosition', `${ bgPosition[0] }% ${ e.target.value }%`, screenView )}
                    />
                  </Col>
                  <Col sm={3} className="p-0">
                    <Input 
                      type="number"
                      value={ bgPosition[1] }
                      onChange={ e => onEdit( 'backgroundPosition', `${ bgPosition[0] }% ${ e.target.value }%`, screenView )} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card>
              <CardHeader>{ Lang[ 'IMAGE_SIZE' ][ selectedLanguageShortname ] }</CardHeader>
              <CardBody>
                <Input 
                  type="select"
                  value={ imageSizeType }
                  onChange={ e => {
                    setImageSizeType( e.target.value )
                    if( e.target.value !== "custom" ){
                      onEdit( 'backgroundSize', e.target.value, screenView )
                    } else {
                      onEdit( 'backgroundSize', 'auto auto', screenView )
                      setImageSize([ 'auto', 'auto' ])
                    }
                  }}>
                  <option value="unset">{ Lang[ 'NOT_SET' ][ selectedLanguageShortname ] }</option>
                  <option value="cover">{ Lang[ 'COVER_WHOLE_CONTAINER' ][ selectedLanguageShortname ] }</option>
                  <option value="custom">{ Lang[ 'CUSTOM_SIZE' ][ selectedLanguageShortname ] }</option>
                </Input>
                {
                  imageSizeType === "custom" && (
                    <Row>
                      <Col sm={6}>
                        <Label>{ Lang[ 'WIDTH' ][ selectedLanguageShortname ] } - px</Label>
                        <Input
                          value={ imageSize[0] ? imageSize[0] !== "auto" ? imageSize[0] : "" : "" }
                          type="number"
                          onChange={ e => onEdit( 'backgroundSize', `${ e.target.value ? e.target.value + 'px' : 'auto' } ${ ( !imageSize[1] || imageSize[1] === "auto" ) ? "auto" : imageSize[1] + "px" }`, screenView )} />
                      </Col>
                      <Col sm={6}>
                        <Label>{ Lang[ 'HEIGHT' ][ selectedLanguageShortname ] } - px</Label>
                        <Input
                          value={ imageSize[1] ? imageSize[1] !== "auto" ? imageSize[1] : "" : "" }
                          type="number"
                          onChange={ e => onEdit( 'backgroundSize', `${ ( !imageSize[0] || imageSize[0] === "auto" ) ? "auto" : imageSize[0] + "px" } ${ e.target.value ? e.target.value + "px" : 'auto' }`, screenView )} />
                      </Col>
                    </Row>
                  )
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
        <div className="justify-content-center d-flex" style={{ height: "90%" }}>
          <Frame
            id={ 'editor-section-renderer' }
            style={{
              width: screenView === 'desktop' ? "100%" : screenView === 'tablet' ? "768px" : "450px",
              minWidth: screenView === 'desktop' && "992px",
              height: '100vh'
            }}
            initialContent={ '<!DOCTYPE html><html><head><link href="/image-block-styles.css" rel="stylesheet"></link><link href="/bootstrap.css" rel="stylesheet"></link></head><body style="overflow-y:scroll;overflow-x:hidden;"><div></div></body></html>' }>
            <StyleRoot>
              <div
                style={{
                  width: '100%',
                  height: '100%'
                }}>
                {
                  stylesheets && stylesheets.length > 0 && stylesheets.map( item => {
                    if( item.type === 'URL' ) {
                      return <link key={ `stylesheet-${ item.id }` } rel="stylesheet" href={ item.content }></link>
                    } else {
                      return <style key={ `stylesheet-${ item.id }` }>
                        { item.content }
                      </style>
                    }
                  })
                }
                <style>{ `.vital-carousel-button-hover-animation:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; } \n.vital-carousel-button-hover-animation:hover:after { width: 100%; }\n.vital-carousel-button-hover-animation:hover .vital-carousel-button-text { color: #000000 !important; }\n\n.vital-carousel-bg-effect:after { position: absolute; display: block; width: 100%; height: 100%; background: linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.9) 63%, #000 100%); top: 0; left: 0; opacity: 0.35; content: ''; z-index: 1; }\n\n.launch-button-hover-animation:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #72376b; transition: 0.4s; }\n.launch-button-hover-animation:hover:before { opacity: 1; transform: scale(1); }\n\n.launch-image-hover-animation:after { content: ''; position: absolute; top: -110%; left: -210%; width: 200%; height: 200%; opacity: 0; transform: rotate(30deg); background: linear-gradient(to right, rgba(245,242,241,0.43) 0%, rgba(245,242,241,0.13) 77%, rgba(245,242,241,0.5) 92%, rgba(245,242,241,0) 100%); z-index:2; transition: all 0.3s, opacity 0s; }\n.launch-image-hover-animation:hover:after { opacity: 1; top: -90%; left: -80%;  }\n\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-image { transform: scale(1.25); }\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-textbox { justify-content: center; bottom: 16px !important; }\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-textbox-text { opacity: 1 !important; }\n.launch-bottom-up-grid:hover .launch-bottom-up-grid-textbox-button { opacity: 1 !important; }\n\n.fashion-carousel-slanted-bg:before { content: ''; width: 100%; height: 100%; background-color: rgba(255,255,255,0.8); display: block; z-index: -1; position: absolute; top: 0; left: 0; transform: rotate(-5deg); }\n\n.fashion-carousel-button-animation-lr:before { content: ''; background-color: #842e2e; width: 0; height: 100%; position: absolute; top: 0; left: 0; z-index: 1;  transition: 0.4s; }\n.fashion-carousel-button-animation-lr:hover:before { width: 100%; }\n\n.fashion-carousel-bg-effect{ filter: contrast(0.5) brightness(1.3) opacity(1); }\n\n.fashion-carousel-bg-effect:after { position:absolute; display: block; width: 100%; height: 100%; top: 0; left: 0; content: ''; z-index: 1; opacity: 0.6; background-image: url(https://fashion-de.oms-suite.de/assets/themes/fashion_de/assets/images/template/muster4.png); }\n\n.fashion-grid:hover .fashion-grid-image { transform: scale(1.2) !important; } \n.fashion-grid:hover .fashion-grid-description { max-height: 100% !important; }\n\n.fashion-button-hover-animation:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(0.5,1); background-color: #842e2e; transition: 0.4s; } \n.fashion-button-hover-animation:hover:before { opacity: 1; transform: scale(1); }\n\n.injoy-button-hover-animation:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; opacity: 0; transform: scale(1,0.5); background-color: #004063; transition: 0.4s; }\n.injoy-button-hover-animation:hover:before { opacity: 1; transform: scale(1); }\n\n.injoy-image-hover-animation:after { content: ''; position: absolute; top: -110%; left: -210%; width: 200%; height: 200%; opacity: 0; transform: rotate(30deg); background: linear-gradient(to right, rgba(245,242,241,0.43) 0%, rgba(245,242,241,0.13) 77%, rgba(245,242,241,0.5) 92%, rgba(245,242,241,0) 100%); z-index:2; transition: all 0.3s, opacity 0s; }\n.injoy-image-hover-animation:hover:after { opacity: 1; top: -90%; left: -80%;  }\n.injoy-image-hover-animation:hover div { transform: scale(1.10); }\n\n.injoy-carousel-button-animation-lr:before { content: ''; background-color: #808080; width: 0; height: 100%; position: absolute; top: 0; left: 0; z-index: 1;  transition: 0.4s; }\n.injoy-carousel-button-animation-lr:hover:before { width: 100%; }\n\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-image { transform: scale(1.25); }\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-textbox { justify-content: center; bottom: 16px !important; }\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-textbox-text { opacity: 1 !important; }\n.injoy-bottom-up-grid:hover .injoy-bottom-up-grid-textbox-button { opacity: 1 !important; }\n\n.plus-icon:before { content: ''; position: absolute; background: #252525; top: 0; left: 50%; width: 1px; height: 100%; margin-left: -1px; }\n.plus-icon:after { content: ''; position: absolute; background: #252525; top: 50%; left: 0; width: 100%; height: 1px; margin-left: -1px; }\n\n.minus-icon:before { content: ''; position: absolute; background: #252525; top: 50%; left: 0; width: 100%; height: 1px; margin-left: -1px; }\n\n.left-right-reverse-primary-animated-button-v2:after { content: ''; position: absolute; top: 0; left: 0; width: 0; height: 100%; z-index: 1; opacity: 1; background-color: #ffffff; transition: 0.4s; }\n\n.left-right-reverse-primary-animated-button-v2:hover:after { width: 100%; }` }</style>
                <CoreRenderFunction
                  item={ selectedDom }
                  selectedLanguageShortname={ selectedLanguageShortname }
                  mode={ 'section-display-edit' }/>
                {
                  javascripts && javascripts.length > 0 && javascripts.map( item => {
                    if( item.type === 'URL' ) {
                      return <script key={ `template-js-${ item.id }` } src={ item.content }></script>
                    } else {
                      return <Helmet key={ `template-js-${ item.id }` }><script>{ item.content }</script></Helmet>
                    }
                  })
                }
              </div>
            </StyleRoot>
          </Frame>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={ () => setShowModal( false ) }>
          { Lang[ 'CLOSE' ][ selectedLanguageShortname ] }
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ImagePosition